import * as React from "react";
import {FormattedMessage} from "react-intl";
import {Link} from "react-router-dom";
import {ColumnsDescription, ColumnWidth} from "../common/ui/table/ControlRoomColumns";
import {AOIMonitor as Notification} from "./model";

export const NotificationColumns: ColumnsDescription<Notification> = {
    username: {
        header: <FormattedMessage id="studio.notifications.notification-columns.username" defaultMessage="User name"/>,
        cellContent(notification) {
            return <Link to={`/notifications/aoi-user/${notification.id}`}
                         onClick={(e) => e.stopPropagation()}>{notification.username}</Link>;
        },
        cellTooltip: (notification) => notification.username,
        columnWidth: ColumnWidth.flex(1),
    },
    email: {
        header: <FormattedMessage id="studio.notifications.notification-columns.email" defaultMessage="Email"/>,
        cellContent(notification) {
            return <div>{notification.email}</div>;
        },
        cellTooltip: (notification) => notification.email,
        columnWidth: ColumnWidth.flex(1),
    },
    aois: {
        header: null,
        cellContent(notification) {
            return <Link to={`/notifications/aois/${notification.id}`} onClick={(e) => e.stopPropagation()}>
                <FormattedMessage id="studio.notifications.notification-columns.aois" defaultMessage="Browse AOIs"/>
            </Link>;
        },
        cellTooltip: () => "Browse AOIs",
        columnWidth: ColumnWidth.pixels(120),
    }
};